import React, { Fragment } from 'react'
import ActionButton from './ActionButton'
import { MenuItem } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import RemoveCourseMemberModal from './RemoveCourseMemberModal'
import CanvasActions from './CanvasActions'
import ForceReadingModal from './ForceReadingModal'
import ForceVideoModal from './ForceVideoModal'

const ActionButtonPeople = props => {
  return (
    <Fragment>
      <ActionButton>
        {props.supportDashboard && (
          <MenuItem
            href={`/account/support_dashboard/${props.coursenum}/${props.account_id}/`}
            className="me-list-item"
          >
            <i className="fal fa-question-circle fa-fw color_teal mr-2" />
            Support Dashboard
          </MenuItem>
        )}
        <RemoveCourseMemberModal
          user_full_name={props.user_full_name}
          user_id={props.user_id}
        />
        {props.courseLms ? (
          <CanvasActions
            user_id={props.user_id}
            user_full_name={props.user_full_name}
          />
        ) : null}
        <MenuItem header>ANALYTICS</MenuItem>
        <ForceReadingModal
          user_full_name={props.user_full_name}
          user_id={props.user_id}
        />
        <ForceVideoModal
          videoData={props.videoData}
          user_full_name={props.user_full_name}
          user_id={props.user_id}
        />
      </ActionButton>
    </Fragment>
  )
}

ActionButtonPeople.propTypes = {
  user_id: PropTypes.string,
  account_id: PropTypes.string,
  user_full_name: PropTypes.string,
  courseLms: PropTypes.bool,
  coursenum: PropTypes.string,
  videoData: PropTypes.array,
  supportDashboard: PropTypes.bool,
}

const mapStateToProps = state => {
  return {
    courseLms: state.courseLms,
    coursenum: state.coursenum,
    videoData: state.videoData,
    supportDashboard: state.supportDashboard,
  }
}

export default connect(mapStateToProps)(ActionButtonPeople)
